import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=1cb10116&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb10116')) {
      api.createRecord('1cb10116', component.options)
    } else {
      api.reload('1cb10116', component.options)
    }
    module.hot.accept("./customerList.vue?vue&type=template&id=1cb10116&", function () {
      api.rerender('1cb10116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/house/customerList.vue"
export default component.exports